import React, { useState, useContext, useEffect } from 'react';

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import DataList from '#DataList'
import {
	faList,
	faMagnifyingGlass,
	faDownload,
	faDisplayChartUpCircleDollar,
	faHandHoldingDollar,
	faEnvelope,
} from '@fortawesome/pro-regular-svg-icons';

const useTableDef = () => {
	return [
		{ label:"Anno", content:async row => row?.year },
		{ label:"Procedura", content:async row => row?.type },
	]
}

export default function WorkflowsList() {
	const api = useContext(APICtx)
	const [ ids, setIds ] = useState([])
	const tableDef = useTableDef()

	const handleRefresh = () =>
		api.call('f24/processes/list', {}).then(setIds)
	useEffect(() => {
		handleRefresh()
	}, [])

	const getRow = _id => api.call('f24/processes/get', { _id })
	const defBtns = [
		{
			icon: faList,
			label: 'Lista anagrafiche',
			linkTo: row => '/f24/' + row._id,
		},
		{
			icon: faEnvelope,
			label: 'Spedizioni mail',
			linkTo: row => `/mailer/v2/f24/${row._id}`,
		},

		{
			icon: faMagnifyingGlass,
			label: 'Anteprima telematici',
			onClick: row => api.storage.download(row.telematicsJwt, true),
			show: row => !!row.telematicsJwt,
		},
		{
			icon: faDisplayChartUpCircleDollar,
			label: 'Scarica telematici',
			onClick: row => api.storage.download(row.telematicsJwt, false),
			show: row => !!row.telematicsJwt,
		},
	]

	return (
		<Tpl title="Generazione F24">
			<DataList def={tableDef} rowActions={defBtns} ids={ids} getRow={getRow} pageSize={30} />
		</Tpl>
	)
}